import { render, staticRenderFns } from "./PSortHeader.vue?vue&type=template&id=77a3bcbc"
import script from "./PSortHeader.vue?vue&type=script&lang=js"
export * from "./PSortHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports